import React from 'react';
import { useScrollContext } from './ScrollableTableWrapper';

/**
 * Composant réutilisable pour les lignes de table avec gestion de la sélection
 * @param {React.ReactNode} children - Contenu de la ligne (cellules <TableCell>)
 * @param {string|number} itemId - ID de l'item de la ligne
 * @param {string|number} selectedId - ID de l'item actuellement sélectionné
 * @param {function} onClick - Fonction appelée au clic sur la ligne
 * @param {string} className - Classes CSS additionnelles
 * @param {boolean} clickable - Si true, la ligne est cliquable avec cursor-pointer (défaut: true)
 */
const TableRow = ({
  children,
  itemId,
  selectedId,
  onClick,
  className = '',
  clickable = true,
  id,
}) => {
  const { hasMoved = false, setHoveredRowId } = useScrollContext();
  
  // Déterminer la classe de la ligne selon si elle est sélectionnée
  const rowClass =
    selectedId === itemId ? 'bg-yellow-50' : 'hover:bg-gray-50';

  const handleClick = (e) => {
    // Empêcher le clic si c'était un drag
    if (hasMoved) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }
    if (onClick) {
      onClick(itemId);
    }
  };

  const handleMouseEnter = () => {
    if (setHoveredRowId) {
      setHoveredRowId(itemId);
    }
  };

  const handleMouseLeave = () => {
    if (setHoveredRowId) {
      setHoveredRowId(null);
    }
  };

  return (
    <tr
      id={id}
      className={`group border-b border-gray-100 ${rowClass} ${clickable ? 'cursor-pointer' : ''} ${className}`}
      onClick={clickable ? handleClick : undefined}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {children}
    </tr>
  );
};

export default TableRow;

